import { createDictionary } from 'utils/ObjectUtils';

export const PREDEFINED_TITLE_KEY = 'predefined_message.title';

export const PREDEFINED_MESSAGE_KEY = createDictionary({
  APPOINTMENT: 'web.message.from.appointment.service',
  INTERVENTION: 'predefined_message.default',
  AUDIT: 'predefined_message.default'
}, 'page.fiche.predefined_message.messages.default_message');
